import React from 'react';
import { Link , useLocation } from 'react-router-dom';
function Nav(){
    const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
    return <>
                <li><Link to='/' className={splitLocation[1] === "" ? "active" : ""}>Home</Link></li>
                <li><Link to='/archievements' className={splitLocation[1] === "archievements" ? "active" : ""}>Archievements</Link></li>
                <li><Link to='/projects-and-clients' className={splitLocation[1] === "projects-and-clients" ? "active" : ""}>Projects & Clients</Link></li>
    </>
}
export default Nav;